<template>
    <div class="w-[260px] min-w-[260px] max-w-[260px] bg-white p-4 box-border rounded-2xl ">
        <p class="font-medium select-none">
            Đầu kéo
        </p>

        <div class="flex mt-3 w-full">
            <div class="min-w-16 w-16">
                <hts-avatar
                    :src="CAvatarUrl"
                    size="small" />
            </div>
            <div class="w-full">
                <h3 class="text-main-text h-[26px] leading-[26px] m-0 p-0 mt-[8px] select-none max-w-full text-ellipsis whitespace-nowrap">
                    <hts-tooltip placement="top">
                        <template #reference>
                            {{ CLicensePlate }}
                        </template>
                        <div>
                            {{ CLicensePlate }}
                        </div>
                    </hts-tooltip>
                </h3>
                <hts-status-dot
                    module="vehicle"
                    :status="CStatus"/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const defaultAvatarUrl = ref('/assets/default-avatar.png')

const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const { journey } = toRefs(props)

const CAvatarUrl = computed(() => {
  return defaultAvatarUrl.value
})

const CLicensePlate = computed(() => {
  return journey.value?.vehicleLicensePlate || journey.value?.vehicleTempLicensePlate || ''
})

const CStatus = computed(() => {
  return journey.value.vehicle?.status || journey.value.vehicleTemp?.status || ''
})

const makeCall = () => {
  const phoneNumber = '+84333466444'

  window.open(`tel:${phoneNumber}`)
}
</script>
